import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import "../styles/Dashboard.css"; // reuse your dashboard grid/card styles

const STUDENT_MODULES = [
  {
    title: "Student List",
    description: "View, search, and manage enrolled students.",
    icon: "📋",
    link: "/admin/manage-student/list"
  },
  {
    title: "Enroll / Promote",
    description: "Enroll new students or promote existing ones to next year.",
    icon: "🆕",
    link: "/admin/manage-student/enroll"
  },
  {
    title: "Attendance",
    description: "Manage batch-wise student attendance.",
    icon: "🗓️",
    link: "/admin/manage-student/attendance"
  },
  {
    title: "ID Card Generator",
    description: "Generate and print ID cards for students.",
    icon: "🪪",
    link: "/admin/manage-student/idcard"
  },
  {
    title: "Bulk Import/Export",
    description: "Upload or download student data in Excel format.",
    icon: "📤",
    link: "/admin/manage-student/bulk"
  },
  {
    title: "Reports & Analytics",
    description: "View student statistics and reports.",
    icon: "📊",
    link: "/admin/manage-student/reports"
  }
];

export default function ManageStudentHome() {
  const location = useLocation();
  // If we are on an actual subpage (not the home), render only the child route
  const atRoot = location.pathname === "/admin/manage-student";

  return atRoot ? (
    <div className="dashboard-wrapper">
      <h2>Manage Students</h2>
      <p>Select an action below to manage students.</p>
      <div className="dashboard-cards">
        {STUDENT_MODULES.map((mod) => (
          <Link to={mod.link} className="dashboard-card" key={mod.title} aria-label={mod.title}>
            <div className="dashboard-card-icon">{mod.icon}</div>
            <div className="dashboard-card-title">{mod.title}</div>
            <div className="dashboard-card-desc">{mod.description}</div>
          </Link>
        ))}
      </div>
    </div>
  ) : (
    <Outlet />
  );
}